<mat-list class="fields">
    <mat-list-item *ngFor="let field of fields; let i = index" draggable="true" (dragstart)="drag($event, field)">
      <!-- <mat-icon [ngStyle]="{color: progress.color, background:progress.background}"
                matListIcon>{{progress.icon}}</mat-icon> -->
      <h3 matLine><strong>{{field.header}}</strong></h3>
      <h4 matLine>{{field.title}}</h4>
    </mat-list-item>
</mat-list>